import { AccountBalancesStatsParam } from '@tassat/fred-extended-definitions';

import { SendPayment } from './sendPayment';
import { ISendFormValues } from '../send/sendForm/types';

export interface ISendPaymentProps {
    title: string;
    transactionValues: ISendFormValues;
    setTransactionValues: (values?) => void;
    handleSend: (sendValues) => void;
    goBack: (event?) => void;
    accountPositionBalance: AccountBalancesStatsParam;
}

export default SendPayment;